(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbs-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dbs-home-reviews')) {
    customElements.define('dbs-home-reviews', class extends HTMLElement {
      connectedCallback() {
        this.attempts = 0;
        this.connectSource();
        this.timer = window.setInterval(() => this.connectSource(), 500);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.observer?.disconnect();
      }

      connectSource() {
        const root = document.querySelector('#carthike-grid-div')?.shadowRoot;
        if (root) {
          window.clearInterval(this.timer);
          if (!this.observer) {
            this.observer = new MutationObserver(() => this.updateSummary(root));
            this.observer.observe(root, { childList: true, subtree: true, characterData: true });
          }
          this.updateSummary(root);
        }
        if (++this.attempts >= 60) window.clearInterval(this.timer);
      }

      updateSummary(root) {
        const header = root.querySelector('.grid-header-container');
        const values = header?.querySelector('h2 + div');
        if (!values) return;
        const rating = Number(values.firstElementChild?.textContent.trim().replace(',', '.'));
        const countText = values.querySelector('span.ml-2')?.textContent;
        const count = Number(countText?.replace(/[^0-9]/g, ''));
        if (!Number.isFinite(rating) || rating <= 0 || rating > 5 || !Number.isInteger(count) || count < 1) return;
        const locale = document.documentElement.lang || 'de';
        const formattedRating = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(rating);
        const formattedCount = new Intl.NumberFormat(locale).format(count);
        this.querySelector('[data-reviews-rating]').textContent = `${formattedRating} / 5`;
        this.querySelector('[data-reviews-count]').textContent = this.dataset.countLabel.replace('__count__', formattedCount);
        this.querySelector('.dbs-home-reviews__stars').style.setProperty('--dbs-rating-fill', `${rating * 20}%`);
        this.querySelector('a').setAttribute('aria-label', this.dataset.ratingLabel.replace('__rating__', formattedRating).replace('__count__', formattedCount));
        this.querySelector('[data-reviews-fallback]').hidden = true;
        this.querySelector('[data-reviews-summary]').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class DbsMobileHeader extends HTMLElement {
    connectedCallback() {
      if (!document.body.classList.contains('dbs-modern')) return;
      this.header = this.closest('.section-header');
      if (!this.header) return;

      this.mobile = window.matchMedia('(max-width: 749px)');
      this.viewport = window.visualViewport;
      this.frame = 0;
      this.scheduleUpdate = this.scheduleUpdate.bind(this);
      this.header.dataset.dbsMobileSticky = 'true';
      this.mobile.addEventListener('change', this.scheduleUpdate);
      window.addEventListener('resize', this.scheduleUpdate, { passive: true });
      this.viewport?.addEventListener('resize', this.scheduleUpdate, { passive: true });
      this.observer = new ResizeObserver(this.scheduleUpdate);
      this.observer.observe(this.header);
      this.update();
    }

    scheduleUpdate() {
      if (!this.frame) this.frame = requestAnimationFrame(() => this.update());
    }

    update() {
      this.frame = 0;
      const mobile = this.mobile.matches;
      const height = mobile ? Math.ceil(this.header.getBoundingClientRect().height) : 0;
      const viewportHeight = this.viewport?.height || window.innerHeight;
      const previewHeight = Math.round(Math.min(230, Math.max(96, (viewportHeight - height - 16) * 0.34)));
      const previewChanged = this.previewHeight !== previewHeight;
      this.previewHeight = previewHeight;

      this.header.classList.toggle('shopify-section-header-sticky', mobile);
      document.documentElement.dataset.dbsMobileHeader = String(mobile);
      document.documentElement.style.setProperty('--dbs-mobile-header-height', `${height}px`);
      document.documentElement.style.setProperty('--dbs-mobile-preview-height', `${previewHeight}px`);
      window.dispatchEvent(new Event('dbs3d:preview-layout'));
      if (mobile && previewChanged && document.getElementById('dbs3d')) window.dispatchEvent(new Event('resize'));
    }

    disconnectedCallback() {
      if (!this.header) return;
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.scheduleUpdate);
      window.removeEventListener('resize', this.scheduleUpdate);
      this.viewport?.removeEventListener('resize', this.scheduleUpdate);
      this.header.classList.remove('shopify-section-header-sticky');
      delete this.header.dataset.dbsMobileSticky;
      if (!document.querySelector('dbs-mobile-header')) {
        delete document.documentElement.dataset.dbsMobileHeader;
        document.documentElement.style.removeProperty('--dbs-mobile-header-height');
        document.documentElement.style.removeProperty('--dbs-mobile-preview-height');
      }
    }
  }

  if (!customElements.get('dbs-mobile-header')) customElements.define('dbs-mobile-header', DbsMobileHeader);

  } catch(e) { console.error(e); }
})();
})();
